<template>
  <div class="card">
    <header class="header-card">
      <p>{{ $t('addEditOrdreTravailTech.caracterique.infoGenerale.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-3">
          <b-field class="obligatoire"
            :label="$t('addEditOrdreTravailTech.caracterique.infoGenerale.dateSouhaite')">
            <b-datepicker show-week-number
                          nearby-selectable-month-days
                          v-model="ordreTravail.dateSouhaitee"
                          icon="calendar-today"
                          :editable="true">
            </b-datepicker>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field
            :label="$t('addEditOrdreTravailTech.caracterique.infoGenerale.datePlanification')">
            <b-datepicker show-week-number
                          nearby-selectable-month-days
                          v-model="ordreTravail.datePlanification"
                          icon="calendar-today"
                          :editable="true">
            </b-datepicker>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('addEditOrdreTravailTech.caracterique.infoGenerale.dateRealisation')">
            <b-datepicker show-week-number
                          nearby-selectable-month-days
                          v-model="ordreTravail.dateRealisation"
                          icon="calendar-today"
                          :editable="true">
            </b-datepicker>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('addEditOrdreTravailTech.caracterique.infoGenerale.dateFacture')">
            <b-datepicker show-week-number
                          nearby-selectable-month-days
                          v-model="ordreTravail.dateFacture"
                          icon="calendar-today"
                          :editable="true">
            </b-datepicker>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field class="obligatoire"
            :label="$t('addEditOrdreTravailTech.caracterique.infoGenerale.typeIntervention')">
            <b-select v-model="ordreTravail.typeOtId" expanded @input="updateListeTache">
              <option v-for="type in typesOT"
                      :key="type.id"
                      :value="type.id">
                {{ type.libelle }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field
            :label="$t('addEditOrdreTravailTech.caracterique.infoGenerale.technicien')">
            <b-autocomplete
              v-model="technicienSelect"
              :data="techniciens"
              field="nomCommercial"
              open-on-focus
              @typing="getTechnicien"
              :loading="isFetching"
              @select="technicien => selectTechnicien(technicien)">
              <template slot="empty">
                <div v-if="!isFetching">
                  {{$t('general.autocomplete.noRslt')}}
                </div>
                <div v-else>
                  {{$t('general.autocomplete.search')}}
                </div>
              </template>
            </b-autocomplete>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('addEditOrdreTravailTech.caracterique.infoGenerale.montantHT')">
            <input-currency v-model="ordreTravail.montantHt">
            </input-currency>
          </b-field>
        </div>
        <div class="column is-3" v-if="agencesSelectionnees.length > 1">
          <b-field class="obligatoire"
                   :label="$t('addEditOrdreTravailTech.caracterique.infoGenerale.agence')">
            <b-select v-model="ordreTravail.agenceId" expanded>
              <option :key="agence.agenceId"
                      :value="agence.agenceId"
                      v-for="agence in agencesSelectionnees">
                {{ agence.libelleAgence }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-3" v-if="afficherProjetDossier">
          <b-field :label="$t('addEditOrdreTravailTech.caracterique.infoGenerale.dossierAssocie')">
            <b-autocomplete :loading="isFetchingDossier"
                            :data="projets"
                            :value="dossierSelect"
                            open-on-focus
                            :ref="'autocomplete_projet'"
                            field="libelle"
                            @select="dossier => setDossierRattachement(dossier)"
                            @typing="getProjectWithDossier">
              <template slot="empty">
                <div v-if="!isFetching">
                  {{$t('general.autocomplete.noRslt')}}
                </div>
                <div v-else>
                  {{$t('general.autocomplete.search')}}
                </div>
              </template>
              <template slot-scope="props">
                <div class="dropdown-item is-paddingless is-disabled"
                      v-if="props.option.isProjet">
                  {{ 'Projet: ' + props.option.libelle }}
                </div>
                <div v-else class="dropdown-item has-text-weight-bold is-paddingless">
                  {{ '- ' +  props.option.libelle }}
                </div>
              </template>
            </b-autocomplete>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field
            :label="$t('addEditOrdreTravailTech.caracterique.infoGenerale.codeFacture')">
            <b-input v-model="ordreTravail.codeFacture">
            </b-input>
          </b-field>
        </div>
        <div class="column is-3" v-if="hasInterventionAffiche">
          <b-field class="obligatoire"
            :label="$t('addEditOrdreTravailTech.caracterique.infoGenerale.lieuDeStockage')">
            <b-autocomplete
              v-model="lieuDeStockageSelected"
              :data="lieuDeStockage"
              field="nomCommercial"
              :loading="isFetching"
              :open-on-focus="true"
              @typing="getLieuxStockage"
              @select="handleLieuDeStockageChange">
              <template #empty>
                {{$t(`general.autocomplete.${!isFetching ? 'noRslt' : 'search'}`)}}
              </template>
            </b-autocomplete>
          </b-field>
        </div>
        <div class="column is-3" v-if="hasInterventionAffiche">
          <b-field class="obligatoire"
            :label="$t('addEditOrdreTravailTech.caracterique.infoGenerale.quantite')">
            <b-input v-model="ordreTravail.otStock.quantite"
              type="number">
            </b-input>
          </b-field>
        </div>
        <div v-if="moduleCampagneActive && hasInterventionAffiche" class="column is-3">
          <b-field
            :label="$t('editionDemandeImpression.infoGenerale.campagne')">
            <b-autocomplete
              v-model="campagne"
              :placeholder="$t('editionDemandeImpression.infoGenerale.campagne')"
              :data="campagnes"
              field="libelle"
              :loading="isFetchingCampagne"
              :open-on-focus="true"
              icon="magnify"
              @input="getCampagnesDebounce"
              @select="option =>
              ordreTravail.campagneId = option ? option.id : null">
              <template #empty>
                {{$t(`general.autocomplete.${!isFetchingCampagne
                  ? 'noRslt' : 'search'}`)}}
              </template>
            </b-autocomplete>
          </b-field>
        </div>
        <div v-if="isTypeOtImpressionAffiche" class="column is-6">
          <b-field :label="$t('addEditOrdreTravailTech.caracterique.infoGenerale.tags')">
            <query-tags-tag-input
              v-model="ordreTravail.tags"
              :tooltipLabel="$t('addEditOrdreTravailTech.caracterique.infoGenerale.tagInfo')"
              :moduleTag="constantes.DEMANDE_IMPRESSION"
              :position="'is-right'"
              field="tag">
            </query-tags-tag-input>
          </b-field>
        </div>
        <div class="column is-12">
          <b-field
            :label="$t('addEditOrdreTravailTech.caracterique.infoGenerale.description')">
            <b-input v-model="ordreTravail.description" type="textarea">
            </b-input>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import inputCurrency from '@/components/general/inputCurrency';
import QueryTagsTagInput from '@/components/general/tagInput/queryTagsTagInput';
import { DEMANDE_IMPRESSION } from '@/configuration/parametrage/tagConf';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { getAll } from '@/api/tiers';
import { getAll as getAllProjet } from '@/api/logistique/projets/index';
import {
  TIERS_TYPE_FOURNISSEUR,
  TIERS_SOUS_TYPE_TECHNICIEN,
} from '@/configuration/tiers/tiersConf';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { get } from '@/api/typeOt';
import { IMPRESSION_AFFICHE } from '@/configuration/logistique/typeOt/typeOtConfig';
import { getAll as getAllLigneCommande } from '@/api/ligneCommande';
import { getByLigneCommandeId as getBonStockByLigneCmd } from '@/api/gabed/bonStock';
import { getAll as getAllCampagnes } from '@/api/campagne';
import { NORMAL, SENS_ACHAT } from '@/configuration/devisConf';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    ordreTravail: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isFetching: false,
      techniciens: [],
      technicienSelect: null,
      projets: [],
      dossierSelect: null,
      isFetchingDossier: false,
      hasInterventionAffiche: false,
      lieuDeStockage: [],
      lieuDeStockageSelected: null,
      campagnes: [],
      campagne: null,
      isFetchingCampagne: false,
      constantes: {
        DEMANDE_IMPRESSION,
      },
    };
  },
  components: {
    inputCurrency,
    QueryTagsTagInput,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    typesOT() {
      return this.parametre(PARAMETRES_KEYS.typeOt);
    },
    afficherProjetDossier() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.afficherProjetDossierLogistiqueTechnique
        .key);
    },
    moduleStockTiersActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
    moduleCampagneActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.campagne.key);
    },
    isTypeOtImpressionAffiche() {
      const typeOt = this.typesOT.find(typeOT => typeOT.id === this.ordreTravail.typeOtId);
      return typeOt?.actionInterventionOt === IMPRESSION_AFFICHE;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    async loadTechnicien(text) {
      this.techniciens = (await getAll({
        query: {
          auto: text,
          societeId: this.ordreTravail.societeId
            ? this.ordreTravail.societeId : this.societeActiveId,
          type: TIERS_TYPE_FOURNISSEUR,
          sousType: [TIERS_SOUS_TYPE_TECHNICIEN],
        },
        limit: NO_PAGINATION,
      })).data.result.items;
    },
    getTechnicien: debounce(async function technicienData(text) {
      try {
        this.techniciens = [];
        this.isFetching = true;
        this.ordreTravail.fournisseurId = null;
        await this.loadTechnicien(text);
        this.isFetching = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetching = false;
        throw e;
      }
    }, 500),
    getLieuxStockage: debounce(async function getLieux(search) {
      try {
        this.isFetching = true;
        this.lieuDeStockage = (await getAll({
          query: {
            auto: search,
            societeId: this.societeActiveId,
            estLieuStockage: true,
          },
        })).data.result.items;
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.isFetching = false;
      }
    }, 300),
    selectTechnicien(newTech) {
      if (!newTech) return;
      this.technicienSelect = newTech.nomCommercial;
      this.ordreTravail.fournisseurId = newTech.id;
    },
    async loadProjet(text) {
      const projet = (await getAllProjet({
        query: {
          projectAndFolderLibelle: text,
          archive: false,
          societeId: this.ordreTravail.societeId
            ? this.ordreTravail.societeId : this.societeActiveId,
        },
        limit: NO_PAGINATION,
      })).data.result.items;
      projet.forEach((projet) => {
        if (projet.dossiers.length > 0) {
          this.projets.push({ libelle: projet.libelle, isProjet: true, id: projet.id });
          projet.dossiers.forEach((dossier) => {
            this.projets.push({
              libelle: dossier.libelle,
              isProjet: false,
              id: dossier.id,
            });
          });
        }
      });
    },
    getProjectWithDossier: debounce(async function projetData(text) {
      try {
        this.projets = [];
        this.isFetchingDossier = true;
        this.ordreTravail.dossierLogistiqueTechniqueId = null;
        await this.loadProjet(text);
        this.isFetchingDossier = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetchingDossier = false;
        throw e;
      }
    }, 500),
    setDossierRattachement(dossier) {
      if (!dossier) {
        return;
      }
      if (dossier.isProjet) {
        this.$refs.autocomplete_projet.setSelected(null);
        return;
      }
      this.dossierSelect = dossier.libelle;
      this.ordreTravail.dossierLogistiqueTechniqueId = dossier.id;
    },
    isImpressionAffiche(typeOt) {
      return this.moduleStockTiersActive
        && typeOt
        && typeOt.actionInterventionOt === IMPRESSION_AFFICHE;
    },
    updateStock(typeOt) {
      if (this.isImpressionAffiche(typeOt)) {
        this.hasInterventionAffiche = true;
        this.ordreTravail.otStock.produitId = typeOt.produitId;
      } else {
        this.hasInterventionAffiche = false;
      }
    },
    async updateListeTache(typeOtId) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const typeOt = (await get(typeOtId)).data.result;
        typeOt.tachesTypeOt.forEach((tache) => {
          tache.realise = false;
          delete tache.id;
        });
        this.updateStock(typeOt);
        this.ordreTravail.taches = typeOt.tachesTypeOt;
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    handleLieuDeStockageChange(option) {
      this.ordreTravail.otStock.lieuDeStockage = option;
      this.ordreTravail.otStock.lieuDeStockageId = option ? option.id : null;
    },
    async initializeStock() {
      const typeOt = this.ordreTravail.typeOtId
        ? this.typesOT.find(typeOT => typeOT.id === this.ordreTravail.typeOtId) : null;
      if (this.isImpressionAffiche(typeOt)) {
        this.hasInterventionAffiche = true;
        const typeOt = this.ordreTravail.typeOtId
          ? this.typesOT.find(typeOT => typeOT.id === this.ordreTravail.typeOtId) : null;
        this.ordreTravail.otStock.produitId = typeOt.produitId;
        this.lieuDeStockageSelected = this.ordreTravail
          .otStock.lieuDeStockage?.nomCommercial ?? null;
        this.campagne = this.ordreTravail?.campagne?.libelle ?? '';
        const ligneCommande = this.ordreTravail.id ? (await getAllLigneCommande({
          query: {
            devisCommandeIds: [this.ordreTravail.id],
            sens: SENS_ACHAT,
            societeId: this.societeActiveId,
            types: [NORMAL],
          },
        }))?.data?.result?.items[0] : null;
        if (!ligneCommande) return;
        const bonStock = (await getBonStockByLigneCmd(ligneCommande.id)).data.result;
        if (!bonStock) return;
        this.ordreTravail.otStock.quantite = this.ordreTravail.otStock.quantite
          ?? bonStock.ligneCommande.quantite;
      }
    },
    getCampagnesDebounce: debounce(async function getCampagne(search) {
      try {
        this.isFetchingCampagne = true;
        this.campagnes = (await getAllCampagnes({
          query: {
            auto: search,
            societeId: this.societeActiveId,
            actif: true,
          },
        })).data.result.items;
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.isFetchingCampagne = false;
      }
    }, 300),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadTechnicien();
      await this.loadProjet();
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.afficherProjetDossierLogistiqueTechnique.key,
        PARAMETRES_INTERNE_KEYS.moduleStockTiers.key,
        PARAMETRES_INTERNE_KEYS.campagne.key,
      ]);
      this.dossierSelect = this.ordreTravail.dossierLogistiqueTechnique
        ? this.ordreTravail.dossierLogistiqueTechnique.libelle : null;
      this.technicienSelect = this.ordreTravail.fournisseur
        ? this.ordreTravail.fournisseur.nomCommercial : null;
      await this.initializeStock();
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>
